import type { FormConfig } from './types.ts';

export const formConfig: FormConfig = [
  {
    id: 'partnerBusinessName',
    inputType: 'TextField',
    label: 'Enter your ID, it can be found [here](documentation)',
    labelLinks: [
      {
        text: 'here',
        url: 'https://www.seek.com',
        target: '_blank',
        hitArea: 'large',
      },
    ],
    placeholder: 'Enter your business name',
    secondaryLabel: 'This is the name of the business you are reporting for',
    required: true,
    initialValue: '',
    type: 'string',
  },
  {
    id: 'exampleEmail',
    inputType: 'Email',
    label: 'Example Email',
    placeholder: 'example@example.com',
    secondaryLabel: 'This is an example of an email field',
    required: true,
    initialValue: '',
    type: 'string',
  },
  {
    id: 'exampleYesNo',
    inputType: 'Select',
    label: 'Example Yes/No',
    placeholder: 'Select an option',
    secondaryLabel: 'This is an example of a Yes/No select field',
    required: true,
    initialValue: '',
    type: 'string',
    other: true,
    optionsColumn: false,
    options: [
      { id: 'exampleYesNo-yes', label: 'Yes', value: 'yes' },
      {
        id: 'exampleYesNo-no',
        label: 'No',
        value: 'no',
        image: { src: './assets/seek-developer.png', alt: 'example image' },
      },
    ],
  },
  {
    id: 'exampleMultiSelect',
    inputType: 'MultiSelect',
    label: 'Example Multi Select',
    placeholder: 'Select multiple options',
    secondaryLabel: 'This is an example of a multi-select field',
    required: false,
    initialValue: [],
    type: 'stringArray',
    other: true,
    optionsColumn: true,
    options: [
      { id: 'exampleMultiSelect-option1', label: 'Option 1', value: 'option1' },
      { id: 'exampleMultiSelect-option2', label: 'Option 2', value: 'option2' },
      { id: 'exampleMultiSelect-option3', label: 'Option 3', value: 'option3' },
      {
        id: 'exampleMultiSelect-option4',
        label: 'Option 4',
        value: 'option4',
        image: { src: './assets/seek-developer.png', alt: 'example image' },
      },
    ],
  },
  {
    id: 'exampleTextArea',
    inputType: 'TextArea',
    label: 'Example Text Area',
    placeholder: 'Enter your text here',
    secondaryLabel: 'This is an example of a text area field',
    required: true,
    initialValue: '',
    type: 'string',
    dependsOn: {
      logicalOperator: 'or',
      dependencies: [
        {
          id: 'exampleMultiSelect',
          value: ['option1', 'option2'],
        },
        {
          id: 'exampleMultiSelect',
          value: ['option3'],
        },
        {
          id: 'exampleYesNo',
          value: 'yes',
        },
      ],
    },
  },
  {
    id: 'phone number',
    inputType: 'TextField',
    placeholder: 'Enter your phone number',
    initialValue: '',
    type: 'string',
    label: 'Phone number',
    required: true,
  },
  {
    id: 'Date',
    inputType: 'Date',
    placeholder: 'Enter your desired date',
    type: 'string',
    initialValue: '',
    label: 'Desired date',
    required: true,
  },
  {
    id: 'exampleNumber',
    inputType: 'Number',
    label: 'Example Number',
    placeholder: 'Enter a number',
    secondaryLabel: 'This is an example of a number field',
    required: true,
    initialValue: 0,
    type: 'number',
  },
  {
    id: 'exampleNumberSelect',
    inputType: 'MultiSelect',
    label: 'Example Number Select',
    secondaryLabel: 'This is an example of a number select field',
    required: true,
    initialValue: [],
    type: 'numberArray',
    optionsColumn: true,
    other: false,
    options: [
      { id: 'exampleNumberSelect-option1', label: '1', value: 1 },
      { id: 'exampleNumberSelect-option2', label: '2', value: 2 },
      { id: 'exampleNumberSelect-option3', label: '3', value: 3 },
      { id: 'exampleNumberSelect-option4', label: '4', value: 4 },
    ],
  },
];
